import { Component, OnInit, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { MarketdateStatus } from './marketdate-status.model';
import { MarketdateStatusService } from './marketdate-status.service';
import { ITEMS_PER_PAGE, Principal } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

@Component({
    selector: 'jhi-marketdate-status',
    templateUrl: './marketdate-status.component.html'
})
export class MarketdateStatusComponent implements OnInit, OnDestroy {
marketdateStatuses: MarketdateStatus[];
    currentAccount: any;
    eventSubscriber: Subscription;
    currentSearch: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdateStatusService: MarketdateStatusService,
        private alertService: AlertService,
        private eventManager: EventManager,
        private activatedRoute: ActivatedRoute,
        private principal: Principal
    ) {
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketdateStatus', 'marketStatus']);
    }

    loadAll() {
        if (this.currentSearch) {
            this.marketdateStatusService.search({
                query: this.currentSearch,
                }).subscribe(
                    (res: Response) => this.marketdateStatuses = res.json(),
                    (res: Response) => this.onError(res.json())
                );
            return;
       }
        this.marketdateStatusService.query().subscribe(
            (res: Response) => {
                this.marketdateStatuses = res.json();
                this.currentSearch = '';
            },
            (res: Response) => this.onError(res.json())
        );
    }

    search(query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    }

    clear() {
        this.currentSearch = '';
        this.loadAll();
    }
    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInMarketdateStatuses();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: MarketdateStatus) {
        return item.id;
    }
    registerChangeInMarketdateStatuses() {
        this.eventSubscriber = this.eventManager.subscribe('marketdateStatusListModification', (response) => this.loadAll());
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-status/marketdate-status.component.ts